var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#459a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.17 4.115h7.16c.324 0 .585.276.585.616v5.538c0 .34-.261.616-.584.616H1.169c-.323 0-.584-.276-.584-.616V4.731c0-.34.261-.616.584-.616ZM0 4.731C0 4.05.523 3.5 1.17 3.5h7.16c.647 0 1.17.551 1.17 1.23v5.54c0 .679-.523 1.23-1.17 1.23H1.17C.522 11.5 0 10.949 0 10.27zm8.075.769c0 .276-.213.5-.475.5a.49.49 0 0 1-.475-.5c0-.276.213-.5.475-.5s.475.224.475.5M5.469 7.462a.564.564 0 0 1 .827 0l2.168 2.282a.32.32 0 0 1 0 .435.28.28 0 0 1-.413 0L5.883 7.897l-2.169 2.282a.28.28 0 0 1-.413 0 .32.32 0 0 1 0-.435zm-3.288.384a.564.564 0 0 1 .827 0l.743.783a.32.32 0 0 1 0 .435c-.114.12-.3.12-.413 0l-.744-.783-1.218 1.283c-.114.12-.3.12-.413 0a.32.32 0 0 1 0-.435zM10.5.75a.5.5 0 1 0-1 0v.75h-.75a.5.5 0 0 0 0 1h.75v.748a.5.5 0 0 0 1 0V2.5h.748a.5.5 0 1 0 0-1H10.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "459a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
});
const SvgAddFilesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddFilesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDEyIDEyIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1wYXRoPSJ1cmwoI2EpIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0xLjE3IDQuMTE1aDcuMTZjLjMyNCAwIC41ODUuMjc2LjU4NS42MTZ2NS41MzhjMCAuMzQtLjI2MS42MTYtLjU4NC42MTZIMS4xNjljLS4zMjMgMC0uNTg0LS4yNzYtLjU4NC0uNjE2VjQuNzMxYzAtLjM0LjI2MS0uNjE2LjU4NC0uNjE2Wk0wIDQuNzMxQzAgNC4wNS41MjMgMy41IDEuMTcgMy41aDcuMTZjLjY0NyAwIDEuMTcuNTUxIDEuMTcgMS4yM3Y1LjU0YzAgLjY3OS0uNTIzIDEuMjMtMS4xNyAxLjIzSDEuMTdDLjUyMiAxMS41IDAgMTAuOTQ5IDAgMTAuMjdWNC43M1ptOC4wNzUuNzY5YzAgLjI3Ni0uMjEzLjUtLjQ3NS41YS40ODguNDg4IDAgMCAxLS40NzUtLjVjMC0uMjc2LjIxMy0uNS40NzUtLjVzLjQ3NS4yMjQuNDc1LjVaTTUuNDY5IDcuNDYyYS41NjQuNTY0IDAgMCAxIC44MjcgMGwyLjE2OCAyLjI4MmEuMzIuMzIgMCAwIDEgMCAuNDM1Yy0uMTE0LjEyLS4yOTkuMTItLjQxMyAwTDUuODgzIDcuODk3bC0yLjE2OSAyLjI4MmMtLjExNC4xMi0uMjk5LjEyLS40MTMgMGEuMzIuMzIgMCAwIDEgMC0uNDM1bDIuMTY4LTIuMjgyWm0tMy4yODguMzg0YS41NjQuNTY0IDAgMCAxIC44MjcgMGwuNzQzLjc4M2EuMzIuMzIgMCAwIDEgMCAuNDM1Yy0uMTE0LjEyLS4zLjEyLS40MTMgMGwtLjc0NC0uNzgzLTEuMjE4IDEuMjgzYy0uMTE0LjEyLS4zLjEyLS40MTMgMGEuMzIuMzIgMCAwIDEgMC0uNDM1TDIuMTggNy44NDZaTTEwLjUuNzVhLjUuNSAwIDEgMC0xIDB2Ljc1aC0uNzVhLjUuNSAwIDAgMCAwIDFoLjc1di43NDhhLjUuNSAwIDAgMCAxIDBWMi41aC43NDhhLjUuNSAwIDEgMCAwLTFIMTAuNVYuNzVaIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgxMnYxMkgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPgo=";